<app-begin [totalSeconds]="survey.total_time" [survey]="survey" [userType]="userType" [learningPathId]="learningPathId" *ngIf="survey && step=='begin'" (onBegin)="onBegin(true)" (onContinue)="onContinue(true)" (onRestart)="onRestart(true)"></app-begin>
<app-fail *ngIf="step=='fail'" (onRestart)="onRestart(true)" [survey]="survey" [learningPathId]="learningPathId"></app-fail>


<div *ngIf="step=='survey'">
  <div id="head_wrap" *ngIf="survey.type != 1">
    <div  class="common-back-btn-sight" id="closeBtn" *ngIf="isOpenClass==0"  (click)="close()">
      <span>×</span>
    </div>

    <!--<h1 id="title" class="fontSize24">能力<span *ngIf="survey.type == 2">前</span><span *ngIf="survey.type == 3">后</span>测</h1>-->
    <h1 id="title" class="fontSize24">能力<span *ngIf="survey.type == 2">诊断</span><span *ngIf="survey.type == 3">考核</span></h1>
  </div>


  <div *ngIf="survey && !userType && (tickTimeData && tickTimeData.tickId)">
    <app-countdown [totalSeconds]="survey.total_time - tickTimeData.usedTime" [remindSeconds]="survey.remind_time" (onTimeout)="onTimeout(true)" (onTimeReminder)="onTimeReminder(true)" [abilityTest]="survey.type != 1"></app-countdown>
  </div>

  <div id="sceneBtn" class="fontSize16" *ngIf="survey.type != 1" (click)="onSceneBtnClick()" >
    {{sceneBtnDetail}}
  </div>

  <div *ngIf="selectedQuestion" id="questionWrap">
    <app-question [question]="selectedQuestion" [autoSlideNext]="currentNumber < totalNumber" [clickable]="clickable" [canSlideRight]="currentNumber > 1" [abilityTest]="survey.type != 1" [canSlideLeft]="currentNumber <= finishedNumber && currentNumber < totalNumber" (outPutClickAble)="setClickAble($event)"  (onAnswer)="onAnswer($event)" (onSlide)="onSlide($event)"></app-question>
    <div id="submit_circle" (click)="onSubmit()">提交</div>
  </div>



  <div id="tip1">测验还有{{survey.remind_time / 60}}分钟了。</div>
  <div id="tip2">
    <div id="tip2_picture">
      <img src="{{assetsRoute}}/picture/feature/clock.svg" alt="" />
<!--      <embed src='{{assetsRoute}}/picture/feature/clock.svg' type="image/svg+xml" width="100%" height="100%"/>-->
    </div>
    <p>到点了，测验结束。</p>
  </div>

  <div id="tip3" class="tip fontSize16">
    <p id="tip3Text">现在退出，结果会不准确。何不一鼓作气，完成测验？</p>
    <button id="quitBtn" class="btnWord  fontSize14" (click)="exit()">现在退出</button>
    <button id="continueBtn" class="btnWord  fontSize14" (click)="continue()">我要做完</button>
  </div>


  <footer>
    <p [ngStyle]="{'font-size': isHarmonyOS ? '16px' : ''}"><span id="pageNumber">{{currentNumber}}</span>&nbsp;/&nbsp;{{totalNumber}}<p>
  </footer>

  <div id="test"></div>

  <div id="shade"></div>
  <div id="shade2" (click)="sceneDetailClose()"></div>

  <div id="scene_text" class="fontSize16 lineHeight24" *ngIf="survey.type != 1">
    <p id="sceneInnerText" [innerHtml]="sceneText"></p>
    <div id="scene_text_btn" (click)="onSceneTextBtnClick()">看完了，开始做题</div>
  </div>

  <div id="sceneBtnDetail" class="fontSize14 lineHeight21" *ngIf="survey.type != 1" (click)="sceneDetailClose()">
    <span id="sceneBtnDetailText">{{sceneBtnDetailText}}</span>
    <div id="sceneBtnDetailArrow"></div>
  </div>
</div>

<div id="surveyReport" *ngIf="step=='tourReport' && survey.type != 1">
  <div id="space">
    <div id="guanbi2"><span id="clos" (click)="exit()">×</span></div>
    <h1 class="fontSize18 shuyu2" *ngIf="survey.type == 2">能力诊断报告列表</h1>
    <h1 class="fontSize18 shuyu2" *ngIf="survey.type == 3">能力考核报告列表</h1>
  </div>
  <div id="reportItemWrap">
    <div *ngIf="item1" class="reportItem" id="reportItem1" (click)="linkToTourReport(item1)">
      <div class="reportItemHeader fontSize18">{{appRename.getShowName("打造高效团队")}}
        <span class="reportItemStatusSuccess fontSize16" *ngIf="item1.level>=5&&survey.type==3">通过</span>
        <span class="reportItemStatusFail fontSize16" *ngIf="item1.level<5&&survey.type==3">未通过</span>
      </div>
      <img src="../{{assetsRoute}}/picture/learningmap/list1.png" alt="" class="reportItemImage" id="reportItemImage1"/>
      <div class="reportItemLevelWrap" *ngIf="survey.type == 2">
        <div class="reportItemPreLevel">
          <span class="fontSize19 reportItemLevelText">L{{item1.level}}</span><span class="fontSize18">&nbsp;/&nbsp;L7</span>
        </div>
        <div class="reportItemBottom">
          <div class="reportItemTop reportItemTop1 level{{item1.level}}"></div>
        </div>
      </div>
      <div class="reportItemLevelWrap"  *ngIf="survey.type ==3">
        <div class="reportItemPostLevel">
          <span class="fontSize19 reportItemLevelText">L{{item1.level}}</span><span class="fontSize18">&nbsp;/&nbsp;L7</span>
        </div>
        <div class="reportItemBottom">
          <div class="reportItemTop reportItemTop1 level{{item1.level}}"></div>
        </div>
      </div>
    </div>
    <div *ngIf="item2" class="reportItem" id="reportItem2"  (click)="linkToTourReport(item2)">
      <div class="reportItemHeader fontSize18">{{appRename.getShowName("授权")}}
        <span class="reportItemStatusSuccess fontSize16" *ngIf="item2.level>=5&&survey.type==3">通过</span>
        <span class="reportItemStatusFail fontSize16" *ngIf="item2.level<5&&survey.type==3">未通过</span>
      </div>
      <img src="../{{assetsRoute}}/picture/learningmap/list2.png" alt="" class="reportItemImage" id="reportItemImage2"/>
      <div class="reportItemLevelWrap" *ngIf="survey.type == 2">
        <div class="reportItemPreLevel">
          <span class="fontSize19 reportItemLevelText">L{{item2.level}}</span><span class="fontSize18">&nbsp;/&nbsp;L7</span>
        </div>
        <div class="reportItemBottom">
          <div class="reportItemTop reportItemTop2 level{{item2.level}}"></div>
        </div>
      </div>
      <div class="reportItemLevelWrap"  *ngIf="survey.type ==3">
        <div class="reportItemPostLevel">
          <span class="fontSize19 reportItemLevelText">L{{item2.level}}</span><span class="fontSize18">&nbsp;/&nbsp;L7</span>
        </div>

        <div class="reportItemBottom">
          <div class="reportItemTop reportItemTop2 level{{item2.level}}"></div>
        </div>
      </div>
    </div>
    <div *ngIf="item3" class="reportItem" id="reportItem3"  (click)="linkToTourReport(item3)">
      <div class="reportItemHeader fontSize18">{{appRename.getShowName("计划与组织")}}
        <span class="reportItemStatusSuccess fontSize16" *ngIf="item3.level>=5&&survey.type==3">通过</span>
        <span class="reportItemStatusFail fontSize16" *ngIf="item3.level<5&&survey.type==3">未通过</span>
      </div>
      <img src="../{{assetsRoute}}/picture/learningmap/list3.png" alt="" class="reportItemImage" id="reportItemImage3"/>
      <div class="reportItemLevelWrap" *ngIf="survey.type == 2">
        <div class="reportItemPreLevel">
          <span class="fontSize19 reportItemLevelText">L{{item3.level}}</span><span class="fontSize18">&nbsp;/&nbsp;L7</span>
        </div>
        <div class="reportItemBottom">
          <div class="reportItemTop reportItemTop3 level{{item3.level}}"></div>
        </div>
      </div>
      <div class="reportItemLevelWrap"  *ngIf="survey.type ==3">
        <div class="reportItemPostLevel">
          <span class="fontSize19 reportItemLevelText">L{{item3.level}}</span><span class="fontSize18">&nbsp;/&nbsp;L7</span>
        </div>
        <div class="reportItemBottom">
          <div class="reportItemTop reportItemTop3 level{{item3.level}}"></div>
        </div>
      </div>
    </div>
    <div *ngIf="item4" class="reportItem" id="reportItem4"  (click)="linkToTourReport(item4)">
      <div class="reportItemHeader fontSize18">{{appRename.getShowName("辅导")}}
        <span class="reportItemStatusSuccess fontSize16" *ngIf="item4.level>=5&&survey.type==3">通过</span>
        <span class="reportItemStatusFail fontSize16" *ngIf="item4.level<5&&survey.type==3">未通过</span>
      </div>
      <img src="../{{assetsRoute}}/picture/learningmap/list4.png" alt="" class="reportItemImage" id="reportItemImage4"/>
      <div class="reportItemLevelWrap" *ngIf="survey.type==2">
        <div class="reportItemPreLevel">
          <span class="fontSize19 reportItemLevelText">L{{item4.level}}</span><span class="fontSize18">&nbsp;/&nbsp;L7</span>
        </div>
        <div class="reportItemBottom">
          <div class="reportItemTop reportItemTop4 level{{item4.level}}"></div>
        </div>
      </div>
      <div class="reportItemLevelWrap"  *ngIf="survey.type ==3">
        <div class="reportItemPostLevel">
          <span class="fontSize19 reportItemLevelText">L{{item4.level}}</span><span class="fontSize18">&nbsp;/&nbsp;L7</span>
        </div>
        <div class="reportItemBottom">
          <div class="reportItemTop reportItemTop4 level{{item4.level}}"></div>
        </div>
      </div>
    </div>
    <div *ngIf="item5" class="reportItem" id="reportItem5"  (click)="linkToTourReport(item5)">
      <div class="reportItemHeader fontSize18">{{appRename.getShowName("协作")}}
        <span class="reportItemStatusSuccess fontSize16" *ngIf="item5.level>=5&&survey.type==3">通过</span>
        <span class="reportItemStatusFail fontSize16" *ngIf="item5.level<5&&survey.type==3">未通过</span>
      </div>
      <img src="../{{assetsRoute}}/picture/learningmap/list5.png" alt="" class="reportItemImage" id="reportItemImage5"/>
      <div class="reportItemLevelWrap" *ngIf="survey.type == 2">
        <div class="reportItemPreLevel">
          <span class="fontSize19 reportItemLevelText">L{{item5.level}}</span><span class="fontSize18">&nbsp;/&nbsp;L7</span>
        </div>
        <div class="reportItemBottom">
          <div class="reportItemTop reportItemTop5 level{{item5.level}}"></div>
        </div>
      </div>
      <div class="reportItemLevelWrap"  *ngIf="survey.type ==3">
        <div class="reportItemPostLevel">
          <span class="fontSize19 reportItemLevelText">L{{item5.level}}</span><span class="fontSize18">&nbsp;/&nbsp;L7</span>
        </div>
        <div class="reportItemBottom">
          <div class="reportItemTop reportItemTop5 level{{item5.level}}"></div>
        </div>
      </div>
    </div>
    <div *ngIf="item6" class="reportItem" id="reportItem6" (click)="linkToTourReport(item6)">
      <div class="reportItemHeader fontSize18">{{appRename.getShowName("影响力")}}
        <span class="reportItemStatusSuccess fontSize16" *ngIf="item6.level>=5&&survey.type==3">通过</span>
        <span class="reportItemStatusFail fontSize16" *ngIf="item6.level<5&&survey.type==3">未通过</span>
      </div>
      <img src="../{{assetsRoute}}/picture/learningmap/list6.png" alt="" class="reportItemImage" id="reportItemImage6"/>
      <div class="reportItemLevelWrap" *ngIf="survey.type == 2">
        <div class="reportItemPreLevel">
          <span class="fontSize19 reportItemLevelText">L{{item6.level}}</span><span class="fontSize18">&nbsp;/&nbsp;L7</span>
        </div>
        <div class="reportItemBottom">
          <div class="reportItemTop reportItemTop6 level{{item6.level}}"></div>
        </div>
      </div>
      <div class="reportItemLevelWrap"  *ngIf="survey.type ==3">
        <div class="reportItemPostLevel">
          <span class="fontSize19 reportItemLevelText">L{{item6.level}}</span><span class="fontSize18">&nbsp;/&nbsp;L7</span>
        </div>
        <div class="reportItemBottom">
          <div class="reportItemTop reportItemTop6 level{{item6.level}}"></div>
        </div>
      </div>
    </div>
    <div *ngIf="item7" class="reportItem" id="reportItem7"  (click)="linkToTourReport(item7)">
      <div class="reportItemHeader fontSize18">{{appRename.getShowName("决策")}}
        <span class="reportItemStatusSuccess fontSize16" *ngIf="item7.level>=5&&survey.type==3">通过</span>
        <span class="reportItemStatusFail fontSize16" *ngIf="item7.level<5&&survey.type==3">未通过</span>
      </div>
      <img src="../{{assetsRoute}}/picture/learningmap/list7.png" alt="" class="reportItemImage" id="reportItemImage7"/>
      <div class="reportItemLevelWrap" *ngIf="survey.type == 2">
        <div class="reportItemPreLevel">
          <span class="fontSize19 reportItemLevelText">L{{item7.level}}</span><span class="fontSize18">&nbsp;/&nbsp;L7</span>
        </div>
        <div class="reportItemBottom">
          <div class="reportItemTop reportItemTop7 level{{item7.level}}"></div>
        </div>
      </div>
      <div class="reportItemLevelWrap"  *ngIf="survey.type ==3">
        <div class="reportItemPostLevel">
          <span class="fontSize19 reportItemLevelText">L{{item7.level}}</span><span class="fontSize18">&nbsp;/&nbsp;L7</span>
        </div>
        <div class="reportItemBottom">
          <div class="reportItemTop reportItemTop7 level{{item7.level}}"></div>
        </div>
      </div>
    </div>
  </div>
  <div id="backButton2" (click)="exit()" *ngIf="item1">
    <img src="../{{assetsRoute}}/picture/learningmap/doublearrow.png" alt="" id="doubleArrow" />
    <span class="fontSize16" id="backText">返回主页</span>
  </div>
</div>

<app-report *ngIf="step=='report' && survey.type == 1" [isOnlyLearningPathCannotBack]="isOnlyLearningPathCannotBack" [surveyId]="survey.id"></app-report>
<app-ability-test-report *ngIf="step=='report' && survey.type != 1" [surveyId]="survey.id" [surveyType]="survey.type" [learningPathId]="learningPathId" [tourSingleReport]="tourSingleReport" (onGoBackSurvey)="goBackSurvey()"></app-ability-test-report>



// WEBPACK FOOTER //
// ./src/app/survey/survey.component.html